import React, { useState, useEffect } from "react";
import LockersSearchList from "../../../../components/LockersSearchList";
import { translate } from "../../../../utils/Common";

const PlatformIncidentSelect = (props) => {
  const { errors, register, nameShow, readOnly, sizeInput, setPlatformId } = props;
  const [selectedPlatformId, setSelectedPlatformId] = useState(null);

  useEffect(() => {
    return () => {
      setSelectedPlatformId(null);
    };
  }, []);

  const handleLockerSelect = (platformId) => {
    setSelectedPlatformId(platformId);
    if (setPlatformId) {
      setPlatformId(platformId);
    }
  };

  return (
    <div className={`input-group ${sizeInput || ""} w-100`} style={{ width: "100%" }}>
      <LockersSearchList
        errors={errors}
        register={register}
        setSelectOption={handleLockerSelect}
        isRequired={false}
        placeholder={translate("global.selectLocker")}
      />
      <input
        type="hidden"
        name="platformId"
        value={selectedPlatformId ?? ""}
        ref={register({
          validate: (value) =>
            value !== "" || translate("global.chooseValidPlatform"),
        })}
      />
    </div>
  );
};

export default PlatformIncidentSelect;
